// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ls-1";
export var messageSideRight = "_ls-2";
export var orderLookupBubbleContainer = "_ls-0";
export var submitButton = "_ls-3";